module.exports = __webpack_public_path__ + "static/img/iphone_head_back.b46af47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_head_back.png
// module id = TNxf
// module chunks = 0